// Configuration utility to centralize environment variables access

export const config = {
  // API Configuration
  api: {
    baseUrlProduction: process.env.REACT_APP_API_BASE_URL_PRODUCTION || "https://be-myemployer.oldmutual.com.gh/api/v1/",
    baseUrlTest: process.env.REACT_APP_API_BASE_URL_TEST || "https://testbe-myemployer.oldmutual.com.gh/api/v1/",
    baseUrlDev: process.env.REACT_APP_API_BASE_URL_DEV || "https://api-dev-pension.oldmutual.com.gh/api/v1/",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || "30000"),
  },

  // Company Information
  company: {
    name: process.env.REACT_APP_COMPANY_NAME || "OLD MUTUAL PENSIONS TRUST GHANA LIMITED",
    address: process.env.REACT_APP_COMPANY_ADDRESS || "No. 4 Dr Paul Aquah Street, Airport Residential Area, Accra, Ghana, P.O. Box AN5754, Accra North, Ghana",
    phone: process.env.REACT_APP_COMPANY_PHONE || "+233 (0)307 000 601",
    email: process.env.REACT_APP_COMPANY_EMAIL || "trust@oldmutual.com.gh",
    website: process.env.REACT_APP_COMPANY_WEBSITE || "www.oldmutual.com.gh",
  },

  // Application Settings
  app: {
    name: process.env.REACT_APP_NAME || "OMA Pensions Portal",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    environment: process.env.REACT_APP_ENVIRONMENT || "development",
    defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "10"),
  },

  // Environment checks
  isDevelopment: process.env.REACT_APP_ENVIRONMENT === "development" || process.env.NODE_ENV === "development",
  isProduction: process.env.REACT_APP_ENVIRONMENT === "production" || process.env.NODE_ENV === "production",
  isTest: process.env.REACT_APP_ENVIRONMENT === "test",
};

// Helper function to get the company contact info as a formatted string
export const getCompanyContactInfo = () => {
  return `Tel: ${config.company.phone}, Email: ${config.company.email}, Web: ${config.company.website}`;
};

// Helper function to get the full company header info
export const getCompanyHeaderInfo = () => {
  return {
    name: config.company.name,
    address: config.company.address,
    contact: getCompanyContactInfo(),
  };
};

export default config;
